import Vue from 'vue';
import moment from 'moment';

const currentLangCode = window.immiObj.currentLangCode ? window.immiObj.currentLangCode: '';

Vue.filter('formatDate', function (value) {
    if (value) {
        let thisDate = value;
        if (typeof value === 'number') {
            thisDate = new Date(value);
        } else {
            thisDate = new Date(value.replace('T', ' ').replace(/-([0-1]?[0-9]|2[0-3]):[0-5][0-9]/g,''));
        }
        return moment(thisDate).format('MM/DD/YYYY hh:mm A');
    }
});

Vue.filter('formatDateRegular', function (value) {
    if (value) {
        const thisDate = new Date(value);
        return moment(thisDate).format('MM/DD/YYYY hh:mm A')
    }
});

Vue.filter('formatDateFullMonth', function (value) {
    if (value) {
        const thisDate = new Date(String(value));
        let localeCode = currentLangCode == 'es' ? 'es' : currentLangCode == 'zh' ? 'zh_cn' : 'en';
        let dateFormat = '';

        if(currentLangCode == 'es') {
            dateFormat = 'DD MMMM, YYYY';
        } else if(currentLangCode == 'zh') {
            dateFormat = 'YYYY MMMM DD';
        } else {
            dateFormat = 'MMMM DD, YYYY';
        }

        return moment(thisDate).locale(localeCode).format(dateFormat);
    }
});

Vue.filter('formatDateWithDay', function (value) {
    if (value) {
        const thisDate = new Date(String(value));
        return moment(thisDate).format('dddd, MMMM DD, YYYY')
    }
});

Vue.filter('formatDateUS', function (value) {
    if (value) {
        let thisDate = value;
        if (typeof value === "number") {
            thisDate = new Date(value);
        } else if (thisDate.indexOf('-') > -1 && (thisDate.indexOf('-') === 4 || thisDate.indexOf('-') === 2) && thisDate.length >= 10) {
            thisDate = value.substring(0,10).replace(/-/g,'/');        
        }
        
        return moment(thisDate).format('MM/DD/YYYY')
    }
});